import { render } from "./agentAdd.vue?vue&type=template&id=0526f405&scoped=true"
import script from "./agentAdd.vue?vue&type=script&lang=js"
export * from "./agentAdd.vue?vue&type=script&lang=js"

import "./agentAdd.vue?vue&type=style&index=0&id=0526f405&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0526f405"]])

export default __exports__